import React from 'react';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneField.css';

/**
 * Voltminton-styled wrapper around react-phone-number-input.
 *
 * value: E.164 string (or undefined when empty)
 * onChange: receives E.164 string (or undefined)
 * defaultCountry: ISO-2 country code, defaults to "IN"
 *
 * Renders a flag dropdown with country search + a clean input that
 * automatically formats to local conventions and stores E.164 (+918884243167).
 */
const KbaPhoneInput = React.forwardRef(({
  value,
  onChange,
  defaultCountry = 'IN',
  placeholder = 'Mobile number',
  required = false,
  testId = 'phone-input',
  className = '',
  ...rest
}, ref) => {
  return (
    <div className={`kba-phone-wrap ${className}`} data-testid={testId}>
      <PhoneInput
        ref={ref}
        international
        countryCallingCodeEditable={false}
        defaultCountry={defaultCountry}
        value={value || ''}
        onChange={(v) => onChange?.(v || '')}
        placeholder={placeholder}
        required={required}
        countrySelectProps={{ unicodeFlags: true }}
        {...rest}
      />
    </div>
  );
});

KbaPhoneInput.displayName = 'KbaPhoneInput';

export { isValidPhoneNumber };
export default KbaPhoneInput;
